module.exports = __webpack_public_path__ + "img/thumb_06.6778fab1.jpg";